module.exports = __webpack_public_path__ + "img/icon (2).3697c40f.png";